import { useState } from 'react';
import type { FilterModel, GridApi } from 'ag-grid-enterprise';

type FilterField = 'accountName' | 'clientName' | 'breakId';

export const useGridFilters = () => {
  const [filters, setFilters] = useState<Record<FilterField, string>>({
    accountName: '',
    clientName: '',
    breakId: '',
  });

  const filterLabels: Record<FilterField, string> = {
    accountName: 'Account Name',
    clientName: 'Client Name',
    breakId: 'Break ID',
  };

  const applyFilters = (gridApi: GridApi, filterState: Record<FilterField, string>) => {
    const model = Object.entries(filterState).reduce<FilterModel>((acc, [key, val]) => {
      if (val) {
        acc[key as FilterField] = {
          filterType: 'text',
          type: 'equals',
          filter: val,
        };
      }
      return acc;
    }, {});

    gridApi.setFilterModel(model);
  };

  const handleFilterChange = (gridApi: GridApi | null, field: FilterField) => (value: string) => {
    const updated = { ...filters, [field]: value };
    setFilters(updated);
    if (gridApi) {
      applyFilters(gridApi, updated);
    }
  };

  return { filters, filterLabels, handleFilterChange, applyFilters };
};
